import styles from './FJAIVideoGeneratorBtnGroup.module.less';
import FJButton, { FJButtonType } from '../../../../common/components/FJButton/FJButton.jsx';
import VideoGradientIcon from '../../../../assets/svg/video-gradient.svg?react';
import FJDownloadIcon from '../../../../assets/svg/download.svg?react';
import classNames from 'classnames';
import FJToolTip from '../../../../common/components/FJToolTip/FJToolTip.jsx';
import ShareSmallIcon from '../../../../assets/svg/share-2.svg?react';
import FJDropDown from '../../../../common/components/FJDropDown/FJDropDown.jsx';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import { useMemo } from 'react';
import FJConstant from '../../../../constants/FJConstant.js';
import FacebookIcon from '../../../../assets/svg/facebook-social.svg?react';
import TwitterIcon from '../../../../assets/svg/twitter-social.svg?react';
// import TumblrIcon from '../../../../assets/svg/tumblr-social.svg?react';
import ShareIcon from '../../../../assets/svg/share.svg?react';
import PropTypes from 'prop-types';

const shareList = [
    { type: FJConstant.FACEBOOK, icon: <FacebookIcon /> },
    { type: FJConstant.TWITTER, icon: <TwitterIcon /> },
    // { type: FJConstant.TUMBLR, icon: <TumblrIcon /> },
    { type: FJConstant.COPY_LINK, icon: <ShareIcon /> },
];
const FJAIVideoGeneratorBtnGroup = props => {
    const { onEditClick, onDownloadClick, shareToSociety, width, addAsEditPageModalBtuStatus, isDownload } = props;

    const _shareOverlay = useMemo(() => {
        return (
            <div className={styles.share_box}>
                <div className={styles.share_title}>{FJLocalStore._('share')}</div>
                <div className={styles.share_content}>
                    {shareList.map(item => (
                        <div
                            key={item.type}
                            className={styles.share_img_box}
                            onClick={() => {
                                shareToSociety && shareToSociety(item.type);
                            }}
                        >
                            {item.icon}
                        </div>
                    ))}
                </div>
            </div>
        );
    }, [shareToSociety]);

    return (
        <div className={styles.box} style={{ minWidth: width }}>
            <FJDropDown zIndex={9999} placement='topCenter' overlay={_shareOverlay} trigger='click'>
                <FJToolTip title={'share'}>
                    <div className={styles.hover_box}>
                        <ShareSmallIcon />
                    </div>
                </FJToolTip>
            </FJDropDown>

            <div className={styles.btn_group}>
                <FJButton
                    text='edit'
                    type={FJButtonType.LIGHT_GRADIENT}
                    icon={<VideoGradientIcon />}
                    className={classNames(styles.btn, styles.edit_btn)}
                    onClick={onEditClick}
                    isLoading={addAsEditPageModalBtuStatus === FJConstant.LOADING}
                />
                <FJButton
                    type={FJButtonType.GRADIENT}
                    text='download'
                    icon={<FJDownloadIcon />}
                    className={styles.btn}
                    onClick={onDownloadClick}
                    isLoading={isDownload}
                />
            </div>
        </div>
    );
};

FJAIVideoGeneratorBtnGroup.propTypes = {
    onEditClick: PropTypes.func,
    onDownloadClick: PropTypes.func,
    shareToSociety: PropTypes.func,
    width: PropTypes.number,
    addAsEditPageModalBtuStatus: PropTypes.string,
    isDownload: PropTypes.bool,
};

export default FJAIVideoGeneratorBtnGroup;
